import {
    RBChannel,
    SearchDeeplink,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';

import parseParentalRating from 'services/data-manager/parsing/utils/parseParentalRating';
import { EventParentalControlRating } from 'services/data-manager/types';

function parseSearchParentalRating(
    program: SearchProgram | SearchDeeplink | undefined,
    channel?: RBChannel | undefined,
): EventParentalControlRating | undefined {
    if (!program?.rating) {
        return parseParentalRating(undefined, channel);
    }

    if ((program?.rating as string) === 'unknown') {
        return EventParentalControlRating.HU18;
    }

    if (
        program?.rating &&
        Object.values(EventParentalControlRating).includes(program?.rating)
    ) {
        return program?.rating;
    }

    return undefined;
}

export default parseSearchParentalRating;
